var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.cmpType,{tag:"component",class:[_vm.componentData.name.toLowerCase(), { disabled: !_vm.componentData.component.enabled }],attrs:{"cmpConfig":_vm.componentData,"fwParams":_vm.instanceParams,"valueSet":_vm.valueSet}})}
var staticRenderFns = []

export { render, staticRenderFns }